import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Notices from '../../components/instrument/Notices';
import withNoticeSubscribe from '../../hoc/withNoticeSubscribe';
import { requestNoticesData } from '../../actions/notices';
import normalizeSymbol from '../../service/normalizesymbol';

function mapStateToProps({ notices }, { symbol }) {
    const normalizedSymbol = normalizeSymbol(symbol);
    const instrument = notices[normalizedSymbol] || {};

    return {
        isLoading: instrument.isLoading || false,
        notices: instrument.notices || [],
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestNoticesData,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withNoticeSubscribe(Notices)
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/Notices.js
 **/